import { render, staticRenderFns } from "./GetGood.vue?vue&type=template&id=7ebe8419&scoped=true&"
import script from "./GetGood.vue?vue&type=script&lang=js&"
export * from "./GetGood.vue?vue&type=script&lang=js&"
import style0 from "./GetGood.vue?vue&type=style&index=0&id=7ebe8419&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebe8419",
  null
  
)

export default component.exports